import { Popconfirm } from 'antd'
import styled from 'styled-components'

export const AntPopconfirm = styled(Popconfirm)`
  .ant-popover-content {
    color: var(--color-mainText);
  }
`
